import React from 'react';
import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import { TypographyAllProps } from 'globals/types';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsCaption from 'ui-elements/typography/FsCaption';

export const ContainerBox = withStyles(({ spacing, palette }: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'stretch',
    padding: spacing(2),
    marginBottom: spacing(1),
    borderRadius: 10,
    backgroundColor: palette.grey[100],
  },
}))((props: BoxProps) => {
  return <Box {...props} />;
});

export const ContentBox = withStyles(({ breakpoints }: Theme) => ({
  root: {
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'space-between',
    alignItems: 'stretch',
    flexWrap: 'wrap',
    [breakpoints.up('lg')]: {
      flexWrap: 'nowrap',
    },
  },
}))((props: BoxProps) => {
  return <Box {...props} />;
});

export const NameBox = withStyles(({ breakpoints }: Theme) => ({
  root: {
    width: '100%',
    [breakpoints.up('md')]: {
      width: 'auto',
    },
  },
}))((props: BoxProps) => {
  return <Box {...props} />;
});

export const HeaderBox = withStyles(({ breakpoints }: Theme) => ({
  root: {
    [breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'flex-start',
    },
    [breakpoints.up('md')]: {
      alignItems: 'center',
    },
  },
}))((props: BoxProps) => {
  return <Box {...props} />;
});

export const ValuesBox = withStyles(({ breakpoints }: Theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'stretch',
    width: '100%',
    [breakpoints.up('sm')]: {
      flexWrap: 'nowrap',
    },
    [breakpoints.up('md')]: {
      width: 'auto',
    },
  },
}))((props: BoxProps) => {
  return <Box {...props} />;
});

export const SingleValueBox = withStyles(
  ({ breakpoints, palette, spacing }: Theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: spacing(2),
      borderRight: `1px solid ${palette.grey[200]}`,
      paddingRight: spacing(2),
      marginRight: spacing(2),
      [breakpoints.up('lg')]: {
        marginTop: 0,
        borderRight: 0,
        paddingRight: 0,
        marginLeft: 0,
        borderLeft: `1px solid ${palette.grey[200]}`,
        paddingLeft: spacing(2),
      },
    },
  })
)((props: BoxProps) => {
  return <Box {...props} />;
});

export const ThickVerticalDivider = withStyles(
  ({ palette, spacing }: Theme) => ({
    root: {
      width: 3,
      backgroundColor: palette.grey[200],
      borderRadius: 3,
      marginRight: spacing(2),
    },
  })
)((props: BoxProps) => {
  return <Box {...props} />;
});

export const Name = withStyles(({ spacing }: Theme) => ({
  root: {
    marginBottom: spacing(0.2),
  },
}))((props: TypographyAllProps) => <FsBodyBold component="h6" {...props} />);

export const Status = withStyles(
  ({ palette, spacing, breakpoints }: Theme) => ({
    root: {
      color: palette.grey[400],
      marginBottom: spacing(3),
      [breakpoints.up('sm')]: {
        marginBottom: 0,
      },
    },
  })
)((props: TypographyAllProps) => <FsBodySmall component="p" {...props} />);

export const StatusLabel = withStyles(({ palette, spacing }: Theme) => ({
  root: {
    color: palette.grey[400],
    marginLeft: spacing(1),
  },
}))((props: TypographyAllProps) => <FsBodySmall component="span" {...props} />);

export const DetailsBox = withStyles(({ breakpoints }: Theme) => ({
  root: {
    display: 'block',
    [breakpoints.up('sm')]: {
      display: 'flex',
      flexWrap: 'wrap',
    },
  },
}))((props: BoxProps) => {
  return <Box {...props} />;
});

export const DetailsInfo = withStyles(({ spacing }: Theme) => ({
  root: {
    marginTop: spacing(1),
    marginRight: spacing(2),
  },
}))((props: TypographyAllProps) => {
  return <FsBodySmall component="p" {...props} />;
});

export const DetailsInfoLabel = withStyles(({ palette, spacing }: Theme) => ({
  root: {
    color: palette.grey[300],
    marginRight: spacing(1),
  },
}))((props: TypographyAllProps) => {
  return <FsCaption component="span" {...props} />;
});

export const Value = withStyles(() => ({}))((props: TypographyAllProps) => {
  return <FsBodyBold component="p" {...props} />;
});

export const ValueCaption = withStyles(({ palette }: Theme) => ({
  root: {
    color: palette.grey[400],
  },
}))((props: TypographyAllProps) => {
  return <FsBodySmall component="p" {...props} />;
});
